<script lang="ts">
import { defineComponent } from 'vue'
import KioskLayout from '@/views/layouts/KioskLayout.vue'

export default defineComponent({
  name: 'App',
  components: {
    'kiosk-layout': KioskLayout
  },
  computed: {
    layout(): string {
      if (this.$route.meta?.layout) {
        return `${this.$route.meta.layout}-layout`
      }
      return 'div'
    },
    defaultFonts(): string[] {
      return [
        'Arvo',
        'Bitter',
        'Cormorant Garamond',
        'Crimson Pro',
        'Lato',
        'Libre Barcode 128',
        'Libre Barcode 128 Text',
        'Libre Barcode 39',
        'Libre Barcode 39 Text',
        'Libre Baskerville',
        'Lora',
        'Merriweather',
        'Merriweather Sans',
        'Montserrat',
        'Noto Serif',
        'Open Sans',
        'Oswald',
        'Outfit',
        'Playfair Display',
        'PT Sans',
        'PT Serif',
        'Raleway',
        'Roboto',
        'Roboto Condensed',
        'Slabo 27px'
      ]
    }
  }
})
</script>

<template>
  <v-app id="application">
    <link v-for="(font, index) in defaultFonts" :key="`${font}-${index}`" rel="stylesheet" :href="`https://fonts.googleapis.com/css2?family=${font}:ital,wght@0,400;0,700;1,400;1,700&display=swap`" type="text/css" />
    <!-- TODO: Handle custom fonts -->
    <v-main>
      <component :is="layout">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.path"></router-view>
        </transition>
      </component>
    </v-main>
  </v-app>
</template>
